import React from 'react';

import { Contract } from '@/types/ContractType';

interface Props {
  contract?: Contract;
  propertyState?: string; // Kept for backward compatibility
}

const RecoveryFund = ({ contract, propertyState }: Props) => {
  // Priority: contract product > agentSellerInfo > prop > fallback
  const state =
    contract?.product?.address?.state ||
    contract?.agentSellerInfo?.propertyState ||
    propertyState ||
    'N/A';

  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Real Estate Recovery Fund
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          A Real Estate Recovery Fund exists to reimburse any persons who have
          obtained a final civil judgment against {state} real estate licensee
          (or a licensee's affiliates) owing to fraud, misrepresentation, or
          deceit in a real estate transaction and who have been unable to
          collect the judgment after exhausting all legal and equitable
          remedies.
        </li>
      </ol>
    </div>
  );
};

export default RecoveryFund;
